export default function PageWrapper({ children, paddingAmount = 6 }) {
  return <div className={`bg-gray-900 pt-${paddingAmount}`}>{children}</div>;
}
